import { render, staticRenderFns } from "./CompanyTransactionList.vue?vue&type=template&id=0f53ff64&scoped=true"
import script from "./CompanyTransactionList.vue?vue&type=script&lang=js"
export * from "./CompanyTransactionList.vue?vue&type=script&lang=js"
import style0 from "./CompanyTransactionList.vue?vue&type=style&index=0&id=0f53ff64&prod&lang=scss&scoped=true"
import style1 from "./CompanyTransactionList.vue?vue&type=style&index=1&id=0f53ff64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53ff64",
  null
  
)

export default component.exports